'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.daysSince;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/daysSince.js
// module id = 487
// module chunks = 0